import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eye, QrCode, UserCircle } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { useApi, responderUrl } from "../lib/api";
import { PageHeader, Empty } from "../components/common";

export default function MyPage() {
  const api = useApi();
  const [people, setPeople] = useState(null);
  useEffect(() => { api.get("/people").then((r) => setPeople(r.data)).catch(() => setPeople([])); }, [api]);
  if (!people) return <div className="text-slate-400">Loading…</div>;
  return (
    <div data-testid="my-page" className="max-w-4xl">
      <PageHeader overline="What responders see" title="My emergency page" />
      <p className="text-sm text-slate-400 mb-6 max-w-2xl">Open the page that appears when someone scans your QR or taps your NFC card. Opening it here is a preview: nobody is alerted and it is not logged.</p>
      {people.length === 0 ? <Empty testid="my-page-empty">No profiles yet. <Link className="underline" to="/app">Create one on Home</Link>.</Empty> : (
        <div className="grid sm:grid-cols-2 gap-4">{people.map((p) => (
          <div key={p.id} className="panel p-5" data-testid={`my-page-person-${p.id}`}>
            <div className="flex items-center gap-3"><UserCircle size={34} className="text-slate-500" /><div className="font-semibold">{p.first_name} {p.last_name}</div></div>
            {p.personal_token ? <div className="flex flex-wrap gap-2 mt-4">
              <Button asChild className="bg-red-600 hover:bg-red-500 text-white"><a href={responderUrl(p.personal_token, "preview")} target="_blank" rel="noreferrer" data-testid={`my-page-open-${p.id}`}><Eye size={16} className="mr-1" />Open my emergency page</a></Button>
              <Button asChild variant="outline"><Link to={`/app/profile/${p.id}/qr`} data-testid={`my-page-qr-${p.id}`}><QrCode size={16} className="mr-1" />My QR</Link></Button>
            </div> : <div className="mt-4 text-sm text-amber-300">Save this profile first. <Link className="underline" to={`/app/profile/${p.id}`} data-testid={`my-page-setup-${p.id}`}>Finish setup</Link></div>}
          </div>))}</div>)}
    </div>
  );
}
